import { render } from "./Footer.vue?vue&type=template&id=09276a47&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=09276a47&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Taiwan_Travel/Taiwan_Travel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09276a47"]])

export default __exports__